import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.reduce";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    @media (min-width: ", "px) {\n      ", "\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from "styled-components";
var tablet_portrait_up = 600;
var tablet_landscape_up = 900;
var desktop_up = 1200;
var big_desktop_up = 1800;
var sizes = {
  tablet_portrait_up: tablet_portrait_up,
  tablet_landscape_up: tablet_landscape_up,
  desktop_up: desktop_up,
  big_desktop_up: big_desktop_up
}; // Iterate through the sizes and create a media template

var media = Object.keys(sizes).reduce(function (acc, label) {
  acc[label] = function () {
    return css(_templateObject(), sizes[label], css.apply(void 0, arguments));
  };

  return acc;
}, {});
export { media };